import { Injectable } from '@angular/core';
import { BaseApi } from './_base-api';
import { GetApiAdapter, getFieldToUpdateModel } from '../adapters';
import { LocationCreate, LocationEntity, LocationHistoryEntity, LocationUpdate, StatusEntity, UpdateLocationTag } from '../models';
import { map } from 'rxjs';
import { flattenLocationsToItems } from '@admin/shared/helpers';
import { DataGetOptions, DataGetRequest } from '@controladad/ng-base';

@Injectable({
  providedIn: 'root'
})
export class LocationApiService extends BaseApi<LocationEntity> {
  constructor() {
    super('', {
      get: '/Location/admin/GetLocationList'
    });
  }

  getLocation(id: number) {
    return http$.get<LocationEntity>(`/Location/admin/GetLocation?Id=${id}`);
  }

  createLocation(model: LocationCreate) {
    return http$.post('/Location/admin/CreateLocation', model);
  }

  updateLocation(id: number, model: LocationUpdate) {
    return http$.put('/Location/admin/UpdateLocation', { id, location: getFieldToUpdateModel(model) });
  }

  deleteLocation(id: number) {
    return http$.delete('/Location/admin/DeleteLocation', { body: { id } });
  }

  getLocationItems() {
    return this.getAll({ filters: [{ key: 'status', value: StatusEntity.Enabled }] }).pipe(map(locations => flattenLocationsToItems(locations)));
  }

  getAllLocations() {
    return this.getAll();
  }

  getAllLocationTags() {
    return this.getAll(undefined, `/Location/admin/GetLocationTagList`);
  }

  exportLocationTags(query?: DataGetRequest) {
    return super.exportAndDownload('/Location/admin/ExportLocationTags', query, 'location-tags');
  }

  locationHistoryAdapter(id: number, options?: DataGetOptions<LocationHistoryEntity>) {
    return GetApiAdapter<LocationHistoryEntity>(`/Location/admin/GetLocationHistory?LocationId=${id}`, options);
  }

  bulkUpdateLocationTags(model: UpdateLocationTag[]) {
    return http$.put('/Location/admin/BulkUpdateLocationTags', model);
  }
}
